import clsx, { type ClassValue } from 'clsx';

/** Об'єднання класів (clsx). */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
